export const useSolutionLinks = function () {
    const {
        public: { drkLegacy }
    } = useRuntimeConfig()

    return [
        {
            title: 'Überblick',
            description: null,
            icon: 'home',
            route: {
                href: drkLegacy + '/start'
            }
        },
        {
            title: 'Mitglieder',
            icon: 'user-group',
            description: null,
            route: {
                href: drkLegacy + '/mv'
            }
        },
        {
            title: 'Technik',
            icon: 'wrench',
            description: null,
            route: {
                href: drkLegacy + '/tec'
            }
        },
        {
            title: 'Adressen',
            icon: 'office-building',
            description: null,
            route: {
                href: drkLegacy + '/adr'
            }
        },
        {
            title: 'Ereignisse',
            icon: 'calendar',
            description: null,
            route: {
                name: 'events'
            }
        },
        {
            title: 'EM Übersicht',
            icon: 'planner',
            description: null,
            route: {
                href: drkLegacy + '/event/drkevents--mode/registration-statistic'
            }
        },
        {
            title: 'Admin',
            icon: 'lightning-bolt',
            description: null,
            route: {
                href: drkLegacy + '/admin'
            }
        }
    ]
}
